import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Birthday", { props: { triggerType: "Birthday", event: "7 days before" } }],
  ["e1", "auto-email", "Happy birthday — here's $20", { props: { subject: "A little something for your birthday 🎂" } }],
  ["w1", "auto-wait", "Wait 5 days", { props: { duration: "5", unit: "days" } }],
  ["c1", "auto-condition", "Redeemed it?", { props: { condition: "Has tag 'birthday-redeemed'" } }],
  ["s1", "auto-sms", "Expires tomorrow", { props: { message: "Your birthday credit expires tomorrow — {{link.shop}}" } }],
  ["w2", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["tg", "auto-tag-remove", "Clear the offer tag", { props: { tag: "birthday-offer-live" } }],
]);

const def: TemplateDef = {
  slug: "birthday-loyalty-club",
  name: "Birthday & Loyalty Club",
  category: "E-commerce",
  tagline:
    "The one email a year nobody minds getting — with a credit that actually expires.",
  description:
    "A free birthday campaign template: a date-based trigger sends a credit a week early, a redeemed? branch texts the people who haven't used it, and the offer tag is cleared when the window closes. Clone it into FrazzleCRM and it runs off the date-of-birth field on the contact.",
  whatsInside: [
    "Birthday trigger firing a week ahead, not on the day",
    "Gift email with a dated credit and a single landing page",
    "Redeemed? branch with an expiry SMS for the people who forgot",
    "Tag cleanup so the offer can't be reused after the window",
  ],
  flow: makeFlow(
    [
      node("n0", "util-note", "Collect the date first", 40, 90, {
        notes:
          "This flow needs a date of birth on the contact. Ask for it at checkout or in the loyalty signup — day and month is enough, and people give it far more readily than a year.",
      }),
      flow("f1", "Birthday Club", 360, 40, 420, 764),
      ...seq.nodes,
      node("sp", "page-sales", "Birthday offer page", 880, 240, { props: { price: "$20 credit" } }),
      node("co", "page-checkout", "Checkout", 1200, 240, { props: { price: "Order total − $20" } }),
      node("out", "outcome-sale", "Birthday order", 1520, 240, { props: { value: "$65 avg" } }),
    ],
    [...seq.edges, edge("f1", "sp"), edge("sp", "co"), edge("co", "out")]
  ),
};

export default def;
